import { Typography } from "@mui/material";
import { useState } from "react";
import Stepper from "./Stepper";
import { SelectFile, DetectRemovals, SubmitRemovals, Done } from "./steps";

const stepLabels = ["Select the File", "Detect Removals", "Done"];
const nextLabels = ["Detect Removals", "Do it!", "Done"];

const BulkRemoveProcess = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [nextStepDisabled, setNextStepDisabled] = useState(true);

  return (
    <>
      <Typography variant="h5">
        Newsletter Bulk Unsubscribe Tool, this allows you remove a number of
        subscriptions from a CSV file.
      </Typography>
      <br />
      <Stepper
        stepLabels={stepLabels}
        nextLabels={nextLabels}
        sx={{ backgroundColor: "#ef535045" }}
        nextStepDisabled={nextStepDisabled}
        setNextStepDisabled={setNextStepDisabled}
      >
        <SelectFile
          onChange={setSelectedFile}
          selectedFile={selectedFile}
          setNextStepDisabled={setNextStepDisabled}
        />
        <DetectRemovals
          selectedFile={selectedFile}
          setNextStepDisabled={setNextStepDisabled}
        />
        <SubmitRemovals
          selectedFile={selectedFile}
          setNextStepDisabled={setNextStepDisabled}
        />
        <Done />
      </Stepper>
    </>
  );
};

export default BulkRemoveProcess;
